import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Row, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
//Ducks
import * as ducks from "../../../../redux/aspirante/expDigitalDucks";
import { getUrlUpload } from "../../../../redux/aspirante/catalogoDucks";
//utils
import * as utils from "../../../../utils";

/**
 * Componente que permite al aspirante seleccinar un tipo de documento para su expediente digital.
 * @returns JSX.Element
 * @author Uriel Carrión
 */
export const CargaArchivos = (props) => {
  const { idConcurso, idConvocatoria } = props.aspirante;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  //State-Redux
  const { tipoDocumentos, tipoDocumentosCopia } = useSelector(
    (state) => state.expDigital
  );
  const { idAspirante, correo } = useSelector((state) => state.usuarioLogin);
  //Hooks
  const [infoDocumento, setInfoDocumento] = useState("");
  const [urlUpload, setUrlUpload] = useState("");
  const [docSelecionado, setDocSelecionado] = useState(undefined);

  useEffect(() => {
    //Se obtiene la url para simular la correcta carga del archivo
    dispatch(getUrlUpload()).then((data) => {
      setUrlUpload(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Función que obtiene el tipo de documento seleccionado
   * @param {number} idTipoDocumento
   */
  const onChange = (idTipoDocumento) => {
    setDocSelecionado(idTipoDocumento); //Se almacena el id en el hook
    //Se busca la especificación del tipo de documento seleccionado para mostrarlo en el AlertGeneric
    const especificacion = tipoDocumentos.find(
      ({ idDocumento }) => idDocumento === +idTipoDocumento
    )?.especificacion;

    //Si el tipo de documento es el cv
    if (idTipoDocumento === 4) {
      // let textoHtml = <div><b>{texto}</b></div>;
      const texto = especificacion.split(",");
      const textoHtml = (
        <div>
          {texto[0]},<b>{texto[1]}</b>
        </div>
      );
      setInfoDocumento(textoHtml);
    } else {
      setInfoDocumento(especificacion);
    }
  };

  /**
   * Función que permite la subida del archivo
   * @param {File} info
   */
  const handleChange = (info) => {
    const { status } = info.file;
    if (status !== "uploading") {
      dispatch(ducks.setLoading(true));
    }
    if (status === "done") {
      dispatch(ducks.setLoading(false));
      agregarDocumento(info.file); //Se agrega el archivo y el idTipo de documento en una lista del state-redux
    } else if (status === "error") {
      const mensaje = "Al adjuntar el archivo, favor de volver a intentar.";
      utils.openNotification("error", utils.ERROR, mensaje);
      dispatch(ducks.setLoading(false));
    }
  };

  /**
   * Función que permite guardar el archivo con el tipo de documento seleccionado
   * @param {File} file
   */
  const agregarDocumento = (file) => {
    //Se construye el object con la información del documento
    const json = {
      idAspirante,
      idTipoDocumento: docSelecionado,
      usuario: correo,
      archivo: file,
      idConcurso,
      idConvocatoria,
    };
    //Se Guarda el documento en la lista del state
    dispatch(ducks.setDocumento(json));
    //Se limpia el select de Tipo de documento
    form.setFieldsValue({ documento: undefined });
    //Se elimina el Tipo de documento del select
    dispatch(ducks.eliminarTipoDocumento(json.idTipoDocumento));
    setDocSelecionado(undefined); //Se limpia el hook del documento seleccionado
    setInfoDocumento(undefined); //Se limpia la información del documento
  };

  return (
    <>      
      <div style={{ marginTop: 25 }}>
        {tipoDocumentosCopia.length >= 1 && (
          <>
            <Form form={form} layout="vertical">
              <Row gutter={24}>
                <Col xxl={19} xl={19} lg={19} md={19} sm={19} xs={24}>
                  <Form.Item label="Tipo de documento" name={"documento"}>
                    <Select
                      style={{ width: "95%" }}
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      placeholder={"Selecciona una opción"}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={onChange}
                    >
                      {tipoDocumentos.map(
                        ({ idDocumento, nombreDocumento }) => (
                          <Select.Option key={idDocumento} value={idDocumento}>
                            {nombreDocumento}
                          </Select.Option>
                        )
                      )}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={24}>
                  <Form.Item label={<br />}>
                    <Upload
                      {...utils.files_max}
                      accept=".pdf,.PDF"
                      showUploadList={false}
                      onChange={handleChange}
                      action={urlUpload}
                    >
                      <Button
                        type="primary"
                        // className="btn-registrar"
                        icon={<UploadOutlined />}
                        disabled={!docSelecionado}
                      >
                        Examinar
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Form>

            <div>
              {infoDocumento && (
                <utils.AlertGeneric type="info" message={infoDocumento} />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
